import { render, staticRenderFns } from "./CreditCards.vue?vue&type=template&id=13c50a82&scoped=true"
import script from "./CreditCards.vue?vue&type=script&lang=js"
export * from "./CreditCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c50a82",
  null
  
)

export default component.exports